// Messages for operator/settings/Jobs (auto-merged into the i18n catalog).
export const en = {
  'operator.jobs.head': 'Background jobs — Operator',
  'operator.jobs.title': 'Background jobs',
  'operator.jobs.desc':
    'Queue depth and failed jobs. Retry a transient failure or discard a dead one.',
  'operator.jobs.count.pending': 'Pending',
  'operator.jobs.count.scheduled': 'Scheduled',
  'operator.jobs.count.failed': 'Failed',
  'operator.jobs.failed_title': 'Failed jobs',
  'operator.jobs.col.job': 'Job',
  'operator.jobs.col.queue': 'Queue',
  'operator.jobs.col.error': 'Error',
  'operator.jobs.col.when': 'Failed at',
  'operator.jobs.col.actions': 'Actions',
  'operator.jobs.retry': 'Retry',
  'operator.jobs.discard': 'Discard',
  'operator.jobs.empty': 'No failed jobs. 🎉',
  'operator.jobs.retried': 'Job re-enqueued.',
  'operator.jobs.discarded': 'Job discarded.',
}

export const zhTW = {
  'operator.jobs.head': '背景工作 — 操作員',
  'operator.jobs.title': '背景工作',
  'operator.jobs.desc': '佇列深度與失敗的工作。重試暫時性失敗或捨棄無法復原的工作。',
  'operator.jobs.count.pending': '待處理',
  'operator.jobs.count.scheduled': '已排程',
  'operator.jobs.count.failed': '失敗',
  'operator.jobs.failed_title': '失敗的工作',
  'operator.jobs.col.job': '工作',
  'operator.jobs.col.queue': '佇列',
  'operator.jobs.col.error': '錯誤',
  'operator.jobs.col.when': '失敗於',
  'operator.jobs.col.actions': '操作',
  'operator.jobs.retry': '重試',
  'operator.jobs.discard': '捨棄',
  'operator.jobs.empty': '沒有失敗的工作。🎉',
  'operator.jobs.retried': '工作已重新排入佇列。',
  'operator.jobs.discarded': '工作已捨棄。',
}
